import { useCallback, useContext, useMemo } from "react";
import { CacheContext } from "../components/managers";

export const CACHE = {
	FAV_BRANDS: "FAV_BRANDS",
	EMAILED_BRANDS: "EMAILED_BRANDS",
	TRACKED_TARGETS: "TRACKED_TARGETS",
};

const useCache = ({ key = "" } = {}) => {
	const { cache, setCache, refStore } = useContext(CacheContext);

	const data = useMemo(
		() => (!key || !(key in cache) ? null : cache[key]),
		[key, cache]
	);

	const setData = useCallback(
		(cb) => {
			if (!key) {
				return;
			}
			setCache((cache) => ({
				...cache,
				[key]: typeof cb === "function" ? cb(cache[key]) : cb,
			}));
		},
		[key, setCache]
	);

	const updateCache = useCallback(
		(cb) =>
			setCache((cache) => (typeof cb === "function" ? cb(cache) : cb)),
		[setCache]
	);

	const setRef = useCallback(
		(value) => {
			refStore.current[key] = value;
		},
		[refStore, key]
	);

	const getRef = useCallback(() => {
		return refStore.current[key];
	}, [refStore, key]);

	return {
		cache,
		setCache: updateCache,
		data,
		setData,
		refStore,
		getRef,
		setRef,
	};
};

export default useCache;
